module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-wedding-plan-other_company_comparison-6431875e7391f98852da3292e32d9988.png";